import { Component, Input } from '@angular/core';

@Component({ standalone: false, selector: 'app-one-column-and-steps',
  templateUrl: './one-column-and-steps.component.html',
  styleUrls: ['./one-column-and-steps.component.scss']
})
export class OneColumnAndStepsComponent {
  @Input()
  public cambiosSinPublicar: boolean;
  public stepsClass = 'steps-column-body';
  public stepsExtendedClass = 'steps-column-body-extended';
}
